module.exports = "/images/icon-not-protected.png?2bc180aeefca3da79f3c147ce5745173";